import styled from 'styled-components';

export const SocialCard = styled.div`
  border: 1px solid #D4D4D4;
  padding: 16px;
  margin: 5px;
  border-radius: 8px;
  min-width: 254px;
  min-height: 92px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  a {
    line-height: 20px;
    overflow: hidden;
    font-weight: bold;
    color: inherit;
  }
`;

export const BlueDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #00B4D8;
`;

export const Cards = styled.div<{ isUserLogged: boolean }>`
  padding: 10px;
  margin: 5px;
  border-radius: 8px;
  display: grid;
  gap: 10px;

  /* Define as colunas dinamicamente */
  grid-template-columns: ${({ isUserLogged }) => 
    `repeat(${isUserLogged ? '4' : '3'}, 1fr)`};

  @media (max-width: 768px) {
    display: flow;
  }
`;